import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "M16.202 0H7.893C6.178 0 4.786 1.336 4.786 2.983V18.79c0 1.65 1.392 2.984 3.107 2.984h8.309c1.718 0 3.11-1.334 3.11-2.984V2.984C19.31 1.336 17.918 0 16.202 0zm1.476 14.334c0 .906-.767 1.64-1.71 1.64H8.128c-.944 0-1.71-.734-1.71-1.64V3.15c0-.906.766-1.64 1.71-1.64h7.841c.943 0 1.71.734 1.71 1.64zm-.755 8.881c0 .433-.367.785-.818.785H7.991c-.451 0-.818-.352-.818-.785s.367-.784.818-.784h8.115c.45 0 .817.35.817.784"
    }, null, -1)
  ])))
}
export default { render: render }